import { loading, success, handleErrorException } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getTruckRoute = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_TRUCK_ROUTE_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(`TruckRoute/GetTruckRoutes`);
      dispatch(success(types.GET_TRUCK_ROUTE_LIST, response.data.Data));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching truck route list. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.GET_TRUCK_ROUTE_LIST_LOADING_ERROR,
          defaultError
        )
      );
    }
    dispatch(loading(types.GET_TRUCK_ROUTE_LIST_LOADING, false));
  };
};

export const getTruckRouteSchedule = id => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TruckRoute/GetTruckRouteScheduleById/${id}`
      );
      dispatch(
        success(types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching truck route schedule. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS_ERROR,
          defaultError
        )
      );
    }
    dispatch(loading(types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS_LOADING, false));
  };
};

export const saveTruckRouteSchedule = payload => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.SAVE_TRUCK_ROUTE_SCHEDULE_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TruckRoute/WriteTruckSchedule',
        payload
      );
      dispatch(success(types.SAVE_TRUCK_ROUTE_SCHEDULE, response.data.Data));
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while saving truck route schedule. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.SAVE_TRUCK_ROUTE_SCHEDULE_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.SAVE_TRUCK_ROUTE_SCHEDULE_LOADING, false));
    }
  };
};

export const clearTruckRouteScheduleData = () => {
  return {
    type: types.GET_TRUCK_ROUTE_SCHEDULE_DETAILS,
    payload: null,
  };
};

export const clearSavedMessage = () => {
  return {
    type: types.CLEAR_SAVE_TRUCK_ROUTE_SCHEDULE,
  };
};
export const clearTruckRouteScheduleErrors = () => {
  return {
    type: types.CLEAR_TRUCK_ROUTE_SCHEDULE_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/state/createedittruckrouteschedule/actions.js